import {computed} from 'vue'
import {useI18n} from 'vue-i18n'

export function useReleaseNotesUrl() {
  const {locale} = useI18n()

  const href = computed(() => {
    switch (locale.value) {
      case 'de':
        return 'https://knowledgebase.rateboard.io/knowledge-base/rateboard-release-notes'
      case 'it':
        return 'https://knowledgebase.rateboard.io/it/knowledge-base/rateboard-release-notes'
      case 'en':
      default:
        return 'https://knowledgebase.rateboard.io/en/knowledge-base/rateboard-release-notes'
    }
  })

  return {href}
}
